import React from 'react';
import { Container, Typography, Box, Grid, Button, IconButton, useTheme, Chip } from '@mui/material';
import BestPractices from '../../components/farm/BestPractices';
import SmartIrrigation from '../../components/smart-farming/SmartIrrigation';
import YieldForecaster from '../../components/smart-farming/YieldForecaster';
import SustainabilityMetrics from '../../components/smart-farming/SustainabilityMetrics';
import PestDetection from '../../components/pest/PestDetection';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import RefreshIcon from '@mui/icons-material/Refresh';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const SmartFarming: React.FC = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header Section */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Box>
          <Typography variant="h4" fontWeight="800" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <SmartToyIcon fontSize="large" color="primary" />
            Precision Agriculture Hub
          </Typography>
          <Typography variant="body1" color="text.secondary">
            AI-driven insights and real-time sensor data for optimal farm management.
          </Typography>
        </Box>
        <Box display="flex" gap={2}>
          <Button 
            variant="outlined" 
            startIcon={<RefreshIcon />}
            sx={{ borderRadius: 2 }}
          >
            Refresh Data
          </Button>
          <Button 
            variant="contained" 
            startIcon={<SettingsInputAntennaIcon />}
            sx={{ 
              borderRadius: 2, 
              boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`
            }}
          >
            Connect New Sensor
          </Button>
        </Box>
      </Box>

      {/* Main Dashboard Grid */}
      <Grid container spacing={3} mb={4}>
        {/* Sustainability Scorecard - Top Row for Impact Visibility */}
        <Grid item xs={12}>
          <SustainabilityMetrics />
        </Grid>

        {/* Left Column: Smart Irrigation */}
        <Grid item xs={12} md={5} lg={4}>
          <SmartIrrigation />
        </Grid>

        {/* Right Column: Yield Forecasting */}
        <Grid item xs={12} md={7} lg={8}>
          <YieldForecaster />
        </Grid>
      </Grid>

      {/* AI Pest Detection Section */}
      <Box mb={6}>
        <PestDetection />
      </Box>

      {/* AI Diagnostics & Best Practices Section */}
      <Box mb={4}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h5" fontWeight="bold">
            AI Diagnostics & Best Practices
          </Typography>
          <Chip label="Powered by TensorFlow" size="small" variant="outlined" />
        </Box>
        <BestPractices />
      </Box>
    </Container>
  );
};

export default SmartFarming;
